import React, { useEffect, useState } from "react";
import { SketchPicker,HuePicker } from "react-color";

import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";

import "./ColorPalette.css";
import RangeSliderBasic from "../RangeSliderBasic";
import RangeSliderColorAlpha from "../RangeSliderColorAlpha";
const  ColorPickerDynamicTwo =({activeColorPickerValue,setActiveColorPickerValue,palletTitle}) =>{
  const [color, setColor] = useState(activeColorPickerValue?.color?activeColorPickerValue?.color:activeColorPickerValue);
  const [colorHex, setColorHex] = useState(rgbaToHex(activeColorPickerValue?.color?activeColorPickerValue?.color:activeColorPickerValue));
 const [colorChanged, setColorChanged] = useState(rgbaToHex(activeColorPickerValue?.color?activeColorPickerValue?.color:activeColorPickerValue));
  
  
                          const colorPickerOptionArray =[     
                                  'rgba(246, 144, 130,1)',      
                              'rgba(188, 176, 221,1)', ,       
                              'rgba(194, 175, 117,1)',
                                   
                            'rgb(152, 247, 239)',    
                              'rgb(254, 184, 98)'      
                              , 'rgb(171, 249, 165)',  
                                   
                            'rgb(237, 246, 115)',    
                              'rgb(106, 211, 141)'      
                              , 'rgb(186, 181, 244)',  
                                   
                            'rgb(239, 149, 240)',    
                              'rgba(211, 164, 106,1)'      
                              , 'rgb(245, 132, 142)',       
                              'rgb(253, 255, 255)',       
                              'rgb(19, 20, 20)'  ];
  const dispatch = useDispatch();
     
      const [activeColor,setActiveColor] = useState(activeColorPickerValue?.color?activeColorPickerValue?.color:activeColorPickerValue)
     const [alpha,setAlpha] = useState(activeColorPickerValue?.alpha?activeColorPickerValue?.alpha:1)
const [palletStatus,setPalletStatus] = useState(true)
function generateColorShades(rgbaColor) {
  const match = rgbaColor.match(/rgba?\s*\(\s*(\d+),\s*(\d+),\s*(\d+),?\s*([0-9.]+)?\s*\)/);

  if (!match) {
    throw new Error("Invalid rgba color format");
  }

  const [_, r, g, b, a] = match;
  const red = parseInt(r);
  const green = parseInt(g);
  const blue = parseInt(b);
  const alpha = parseFloat(a ?? 1); // default to 1 if alpha is missing

  const result = { alpha: alpha };
  for (let i = 1; i <= 10; i++) {
    const newAlpha = (i / 10).toFixed(1);
    result[`color${i}`] = `rgba(${red}, ${green}, ${blue}, ${newAlpha})`;
  }

  return result;
}
     useEffect(()=>{
       setPalletStatus(false)
   setTimeout(()=>{  setPalletStatus(true)

   },0)
     },[  ])
    const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
        {
          
          dispatch({type: "CURSOR",payload:true  });
      
          dispatch({type: "CURSORTEXT",payload:CursorText})
          dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
          dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
        }
         
        const handleMouseLeave = () => {
          
          dispatch({type: "CURSOR",payload:false})
      
          dispatch({type: "CURSORTEXT",payload:""})
      
          dispatch({type: "CURSORTEXTBG",payload:""})
          dispatch({type: "CURSORTEXTCOLOR",payload:""})
        
      
      }
     
  const handleChange = (newColor) => {
    let rgbacolor= hexToRgba(newColor?.hex);
    setColor(hexToRgba(newColor?.hex));
    setColorHex((newColor?.hex)); 
    setColorChanged(newColor)
    setActiveColorPickerValue({color:rgbacolor,alpha:alpha,colors:generateColorShades(rgbacolor)});
  };

  function hexToRgba(hex) {
  // Remove the # if present
  hex = hex?.replace(/^#/, "");

  if (![3, 4, 6, 8].includes(hex?.length)) {
    // throw new Error("Invalid HEX color format");
  }

  // Expand short hex (e.g., #abc or #abcd) to full form
  if (hex?.length === 3 || hex?.length === 4) {
    hex = hex?.split("").map(char => char + char).join("");
  }

  // Extract RGB components
  const r = parseInt(hex?.slice(0, 2), 16);
  const g = parseInt(hex?.slice(2, 4), 16);
  const b = parseInt(hex?.slice(4, 6), 16);

  // Extract Alpha if present
  let a = alpha;
  if (hex?.length === 8) {
    a = parseInt(hex.slice(6, 8), 16) / 255;
    a = Math.round(a * 100) / 100; // Round to 2 decimal places
  }

  return `rgba(${r}, ${g}, ${b}, ${a})`;
}
  function rgbaToHex(rgba) {
    // Extract RGBA values using regex
    const match = rgba?.match(/rgba?\((\d+),\s*(\d+),\s*(\d+),?\s*([\d\.]+)?\)/);
  
    if (!match) { return
    //   throw new Error("Invalid RGBA color format");
    }
  
    let r = parseInt(match[1]);
    let g = parseInt(match[2]);
    let b = parseInt(match[3]);
    let a = match[4] !== undefined ? parseFloat(match[4]) : 1;
  
    // Validate and clamp values
    r = Math.min(255, Math.max(0, r));
    g = Math.min(255, Math.max(0, g));
    b = Math.min(255, Math.max(0, b));
    a = Math.min(1, Math.max(0, a));
  
    // Convert RGB to HEX
    const hex = ((r << 16) | (g << 8) | b).toString(16).padStart(6, "0");
  
    // Convert Alpha to HEX (if less than 1)
    const alphaHex = a < 1 ? Math.round(a * 255).toString(16).padStart(2, "0") : "";
  
    return `#${hex}${alphaHex}`.toUpperCase();
  }
  

  return (<div className="colorPickerDynamicTwo" style={{boxShadow:"0 7px 20px 0 rgba(1,1,1,0.051)" ,overflow:"hidden",border:"3px solid rgba(144, 202, 249,1)",background:"#fff",padding: "8px",paddingTop:"3px", borderRadius:"20px" }}><h2>{palletTitle}</h2><div style={{display:"flex",justifyContent:"space-around"}}>
    <div style={{  width:"130px", }}>
      
      <SketchPicker color={colorChanged}
        onChange={handleChange}
        width="220px"
        disableAlpha // Hides the alpha slider
        presetColors={[]} // Remove preset colors
        
        styles={{
          default: {
            picker: {
              boxShadow: "0 2px 10px rgba(0, 0, 0, 0.01)",
              borderRadius: "0px",
              padding: "0px",
            },
          },
        }} />
      
      <div className="gridForColorTextBox" style={{display:"none"}}> 
        <input className="input-textbox-color" style={{border:"1px solid rgba(144, 202, 249,0.4)"}} type="text" value={color?.toLocaleUpperCase()} 
         onChange={(e)=>{setColor(e.target.value)}}/>
         <div
        style={{
          
          backgroundColor: color,border:"1px solid  rgba(144, 202, 249,0.4)"
        }} className="colorBoxLeft"
      > </div>
      </div>
     
     
 <div className="" style={{marginTop:"-40px",marginLeft:"-10px"}}>
<button className="colorPickerButtonFill" onClick={()=>{
  setActiveColor(color);setColorChanged(color);
  setColorHex(rgbaToHex(color));setAlpha(alpha);setActiveColorPickerValue({color:(color),alpha:alpha,colors:generateColorShades(color)})}}>Save</button>
<button className="colorPickerButtonBlank" onClick={()=>{
    setColor(activeColor);setColorChanged(activeColor);
  setColorHex(rgbaToHex(activeColor));  setActiveColorPickerValue({color:(activeColor),alpha:alpha,colors:generateColorShades(activeColor)});}}>Reset </button>
</div>
    </div>
    
    <div style={{padding: "5px",width:"130px",background:"#fff" }}>
        <div className="gridForColorBoxSquare" style={{marginTop:"-19px",width:"100%",marginLeft:"-10px"}}>
{colorPickerOptionArray.map((color, index) => (
        <div 
        onMouseEnter={()=>handleMouseEnter("","","")}
onMouseLeave={handleMouseLeave} 
        onClick={()=>{
           let hexMy= rgbaToHex(color)
            setAlpha(alpha); setColorChanged(hexMy); setColor((color));setColorHex(rgbaToHex(color));  setActiveColorPickerValue({color:hexToRgba(hexMy),alpha:alpha,colors:generateColorShades(hexToRgba(hexMy))});
             setPalletStatus(false)
   setTimeout(()=>{  setPalletStatus(true)

   },110)
        }}
          key={index} className="colorBoxSquare" style={{background:color,border:"3px solid #555",position:"relative",padding:"0px",borderRadius:"50%"}}> <div className="" style={{background:color,border:"4px solid #fff",width:"11px",height:"11px",padding:"2px",borderRadius:"50%"}}></div></div>))
          }
</div>
     <div  style={{display:"flex",justifyContent:"space-around",position:"relative",marginTop:"20px",height:"50px"}}>

 {palletStatus&&<RangeSliderColorAlpha  setSliderVal={(val)=>{  setAlpha(val);setActiveColorPickerValue({color:(hexToRgba(colorHex)),alpha:alpha,colors:generateColorShades(hexToRgba(colorHex))})}} showMarkerColor={(hexToRgba(colorHex))}  sliderVal={alpha} />}
           </div></div></div></div>
  );
}

export default ColorPickerDynamicTwo;
